import React from "react";
import { Activity, ShieldCheck, TrendingUp, LayoutDashboard } from "lucide-react";

export default function Login() {
  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen flex bg-navy text-white">
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-14 border-r border-surface-hover bg-surface">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-gold flex items-center justify-center">
            <Activity className="w-6 h-6 text-navy" />
          </div>
          <span className="font-heading text-xl font-bold">PulseBoard</span>
        </div>
        <div>
          <h1 className="font-heading text-5xl font-extrabold leading-tight mb-6">
            One board for your<br /><span className="text-gold">entire content engine.</span>
          </h1>
          <p className="text-slatetext text-lg max-w-md">
            Track PR, social, influencers, video, writing and design — with live KPIs,
            goal tracking and an AI intelligence panel that never sleeps.
          </p>
          <div className="mt-10 space-y-4">
            {[["Auto-generated KPI scorecards", LayoutDashboard],
              ["Content pipeline visibility", TrendingUp],
              ["AI viral & ROI intelligence", ShieldCheck]].map(([t, Icon]) => (
              <div key={t} className="flex items-center gap-3 text-slatetext">
                <Icon className="w-5 h-5 text-gold" /> <span>{t}</span>
              </div>
            ))}
          </div>
        </div>
        <p className="text-xs text-slatetext">© 2026 PulseBoard · Content & Brand Command Center</p>
      </div>

      <div className="flex-1 flex items-center justify-center p-8">
        <div className="w-full max-w-md">
          <div className="lg:hidden flex items-center gap-3 mb-10">
            <div className="w-10 h-10 rounded-lg bg-gold flex items-center justify-center">
              <Activity className="w-6 h-6 text-navy" />
            </div>
            <span className="font-heading text-xl font-bold">PulseBoard</span>
          </div>
          <h2 className="font-heading text-3xl font-bold mb-2">Welcome back</h2>
          <p className="text-slatetext mb-8">Sign in with your Google account to access the dashboard.</p>
          <button
            data-testid="google-login-button"
            onClick={handleLogin}
            className="w-full flex items-center justify-center gap-3 bg-white text-navy font-semibold py-3.5 rounded-lg hover:bg-slate-100 transition-colors duration-200"
          >
            <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="" className="w-5 h-5" />
            Continue with Google
          </button>
          <p className="text-xs text-slatetext mt-6 text-center">
            Each team member sees their own view plus the shared dashboard.
          </p>
        </div>
      </div>
    </div>
  );
}
